import {Agent} from "@/models/Agent";
import {IStoreService} from "@/services/IStoreService";
import {StateMachine} from "frontend-core";
import {injectable} from "tsyringe";

@injectable()
export class StoreService implements IStoreService {
    public currentAgent: Agent | null = null;
    public isManualLogout: boolean = false;
    public currentPath: string | null = null;

    public readonly appState: StateMachine = new StateMachine(
        "loading",
        {
            loading: ["idle"],
            idle: ["loading"],
        },
    );
}
